<template>
  <div class="d-flex flex-column h-100">
    <div class="d-flex mb-2">
      <input-debounced
          v-model="filters.search"
          clearable
          :autofocus="true"
          placeholder="Search"
      ></input-debounced>
    </div>
    <permission-list :items="filtered"></permission-list>
  </div>
</template>

<script>
import PermissionList from './permission-list';
import InputDebounced from '../../../input-debounced';
import eventBus from '../../../../event-bus';

export default {
  components: {
    PermissionList,
    InputDebounced,
  },

  data() {
    return {
      items: [],
      filters: {},
    };
  },

  computed: {
    /**
     * @return {Array}
     */
    filtered() {
      return _.filter(this.items, ({name, description}) => {
        const search = _.get(this.filters, 'search', '').toLowerCase();

        return !search
            || name.toLowerCase().includes(search)
            || description.toLowerCase().includes(search);
      });
    },
  },

  methods: {
    /**
     * @param {Array} permissions
     */
    onPermissionListChange({permissions}) {
      this.items = permissions;
    },
  },

  mounted() {
    eventBus.$on('permission-list-change', this.onPermissionListChange);
  },

  beforeDestroy() {
    eventBus.$off('permission-list-change', this.onPermissionListChange);
  },
}
</script>
